import styled from 'styled-components';
import { StyledCard } from '../../../components/Card.component';
import { StyledTableRows } from '../../../components/Table/Table.component';

export const StyledInternshipMentors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const StyledInternshipsPage = styled.div`
  padding: 22px;

  ${StyledCard} {
    max-height: calc(100vh - 44px - 61px);
    overflow: hidden;

    ${StyledTableRows} {
      max-height: calc(100vh - 44px - 61px - 100px);
    }
  }
`;
